module.exports = __webpack_public_path__ + "static/media/tick-icon.829282b7.png";